import React, { useState, useEffect } from 'react';

const WindowListPopup = ({ 
  isOpen, 
  onClose, 
  selectedWindowItem 
}) => {
  const [activeUnitTab, setActiveUnitTab] = useState(null);

  // Update activeUnitTab when selectedWindowItem changes
  useEffect(() => {
    if (selectedWindowItem?.applied_areas?.length > 0) {
      setActiveUnitTab(selectedWindowItem.applied_areas[0].unit_no);
    }
  }, [selectedWindowItem]);

  if (!isOpen || !selectedWindowItem) return null;

  return (
    <>
      {/* Overlay - semi-transparent background */}
      <div className="fixed inset-0 bg-black bg-opacity-50 z-40" onClick={onClose}></div>
      
      {/* Bottom sheet popup with improved UI and rounded top */}
      <div className="fixed bottom-0 left-0 right-0 bg-white shadow-xl z-50 rounded-t-3xl border-t border-l border-r border-gray-300 max-w-md mx-auto">
        {/* Handle for dragging - adds a nice touch */}
        <div className="w-16 h-1.5 bg-gray-300 rounded-full mx-auto mt-3 mb-4"></div>
        
        {/* Header with title and close button */}
        <div className="flex justify-between items-center px-5 pb-3">
          <h3 className="text-lg font-bold text-gray-800">
            {selectedWindowItem?.application_areas?.area_name}
            <span className="text-red-500 ml-2">
              ({selectedWindowItem?.application_areas?.count})
            </span>
          </h3>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-red-500 transition-colors"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        
        {/* Divider */}
        <div className="h-px bg-gray-200 w-full"></div>
        
        {/* Product name section */}
        <div className="mt-4 ml-4">
          <p className="text-lg text-black font-semibold">{selectedWindowItem?.item_name || selectedWindowItem?.product_name}</p>
        </div>
        
        {/* Unit Tabs */}
        <div className="flex overflow-x-auto border-b border-gray-200 mt-4 pb-1">
          {(() => {
            // Get unique unit numbers
            const unitNumbers = [...new Set(selectedWindowItem?.applied_areas?.map(item => item.unit_no))];
            
            return unitNumbers.map(unitNo => (
              <button
                key={unitNo}
                onClick={() => setActiveUnitTab(unitNo)}
                className={`flex-shrink-0 py-2 px-4 text-center font-medium ${
                  activeUnitTab === unitNo 
                    ? 'text-red-600 border-b-2 border-red-600' 
                    : 'text-gray-500 hover:text-gray-700'
                }`}
              >
                Unit {unitNo || "N/A"}
              </button>
            ));
          })()}
        </div>
        
        {/* Content for selected unit */}
        <div className="max-h-[50vh] overflow-y-auto p-4">
          {(() => {
            // Filter windows for the selected unit
            const windowsInSelectedUnit = selectedWindowItem?.applied_areas?.filter(
              window => window.unit_no === activeUnitTab
            );
            
            if (!windowsInSelectedUnit || windowsInSelectedUnit.length === 0) {
              return (
                <div className="text-center py-6 text-gray-500">No windows found for this unit</div>
              );
            }
            
            return (
              <div>
                {/* Windows in this unit */}
                <div className="ml-2">
                  {windowsInSelectedUnit.map((window, index) => (
                    <div key={index} className="py-2 border-b border-gray-100 last:border-b-0">
                      <div className="flex items-center">
                        {/* Green checkmark */}
                        <span className="text-green-500 mr-2">
                          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                          </svg>
                        </span>
                        
                        {/* Room name */}
                        <div className="font-medium text-gray-800">
                          {window.room_name} - <span className="text-black font-semibold">{window.asset_count || 0} Windows</span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            );
          })()}
        </div>
      </div>
    </>
  );
};

export default WindowListPopup;
